import { render, staticRenderFns } from "./GerenciarUsuarioPermissaoModal.vue?vue&type=template&id=3fbdbaf6&scoped=true"
import script from "./GerenciarUsuarioPermissaoModal.vue?vue&type=script&lang=js"
export * from "./GerenciarUsuarioPermissaoModal.vue?vue&type=script&lang=js"
import style0 from "./GerenciarUsuarioPermissaoModal.vue?vue&type=style&index=0&id=3fbdbaf6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbdbaf6",
  null
  
)

export default component.exports